
































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ViewLoader extends Vue {
  @Prop({ default: "0" }) readonly marginTopPercentage!: string;
  @Prop({ default: "0" }) readonly marginTopPixels!: string;
  @Prop({ default: "white" }) readonly borderColor!: string;

  get marginTopStyle(): string {
    if (parseInt(this.marginTopPercentage, 10) > 0) {
      return "margin-top:" + this.marginTopPercentage + "%;";
    } else {
      return "margin-top:" + this.marginTopPixels + "px;";
    }
  }

  get primaryColor(): boolean {
    return this.borderColor == "primary";
  }

  get whiteColor(): boolean {
    return this.borderColor == "white";
  }
}
